<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { getBranches } from '@/utils/branch';

export default {
inject: ['setLoading'],  
  props:{
   roles: {
    type: Array,
    required: true
   },
  },
  data() {
    return {
     errors: {}, 
     id: '',
     role_id: '',
     parent_id: null,
     branch_id: null,
     name: '',
     email: '',
     mobile: '',
     password: '',
     users: [],
     branches: [],
     can_view_all: false,
     data_transfer_to_user_id: '',
    };
  },
  computed: {
   filteredUsers() {
    return this.users.filter(user => user && user.id !== this.id);
   }
  },
  mounted(){
   this.getAllUsers();
   this.allBranches();
  },
  methods: {
   async allBranches(){
    this.setLoading(true);
    try{
     this.branches = await getBranches();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }, 
   add(){
    this.resetForm();
   },
   async getAllUsers(){
    try{
    const response = await axios.get('/users/all-users');
    this.users = response.data.data; 
    }catch(error){
     console.log(error.message);
    } 
   },
   
   editAdmin(admin) {
    this.id = admin.id;
    this.role_id = admin.role_id;
    this.parent_id = admin.parent_id;
    this.branch_id = admin.branch_id;
    this.name = admin.name;
    this.email = admin.email;
    this.mobile = admin.mobile;
    this.password = admin.password;
    this.can_view_all = !!admin.can_view_all;
   },  

   async saveSubAdmin(){
    this.errors = {};
    this.setLoading(true); 

    try{
     const payload = {
      id: this.id, 
      role_id: this.role_id,  
      parent_id: this.parent_id,
      branch_id: this.branch_id,      
      name: this.name,
      email: this.email,
      mobile: this.mobile,
      password: this.password,
      can_view_all: this.can_view_all,
     }; 
     let response = [];
     if(this.id){
      //UPDATE USER
      response = await axios.put('/users/update', payload);
     }else{
      //CREATE
      response = await axios.post('/users/create-subadmin', payload);
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.closeModal('admin_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){  
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteAdmin(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const response = await axios.post('/users/delete', {
     id: this.id, 
     data_transfer_to_user_id: this.data_transfer_to_user_id 
    });
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   }
  }, 

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.role_id = '';
   this.branch_id = null;
   this.name = '';
   this.email = '';
   this.mobile = '';
   this.password = '';
   this.can_view_all = false;
   this.data_transfer_to_user_id = '';
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="admin_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} User</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="saveSubAdmin">
        <div class="modal-body pb-0">
        
        <div class="row">
         
         <div class="col-md-7">
         <div class="mb-3">
          <label class="form-label">Name</label>
          <input type="text" class="form-control" v-model="name" />
          <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
         </div>
         </div>

         <div class="col-md-5">
         <div class="mb-3">
          <label class="form-label">Mobile No</label>
          <input type="text" class="form-control" v-model="mobile" />
          <div v-if="errors.mobile" class="text-danger small mt-1">{{ errors.mobile[0] }}</div>
         </div>
         </div>
              
        </div>

        <div class="row">
         
         <div class="col-md-7">
         <div class="mb-3">
          <label class="form-label">User ID</label>
          <input type="text" class="form-control" v-model="email" />
          <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
         </div>
         </div>

         <div class="col-md-5">
         <div class="mb-3">
          <label class="form-label">Password</label>
          <input type="text" class="form-control" v-model="password" />
          <div v-if="errors.password" class="text-danger small mt-1">{{ errors.password[0] }}</div>
         </div>
         </div>
              
        </div>

        <div class="row">
         
         <div class="col-md-6">
         <div class="mb-3">
          <label class="form-label">Role</label>
          <select class="form-control" v-model="role_id">
           <option value="">Choose any</option>
           <option v-for="(row, index) in roles" :key="row.id" :value="row.id">{{ row.name }}</option>
          </select>
          <div v-if="errors.role_id" class="text-danger small mt-1">{{ errors.role_id[0] }}</div>
         </div>
         </div>

         <div class="col-md-6">
         <div class="mb-3">
          <label class="form-label">Branch</label>
          <select class="form-control" v-model="branch_id">
           <option value="">Choose any</option>
           <option v-for="(row, index) in branches" :key="row.id" :value="row.id">{{ row.name }} ({{ row.code }})</option>
          </select>
          <div v-if="errors.branch_id" class="text-danger small mt-1">{{ errors.branch_id[0] }}</div>
         </div>
         </div>

         <div class="col-md-6">
         <div class="mb-3">
          <label class="form-label">Parent User</label>
          <select class="form-control" v-model="parent_id">
           <option value="">Choose any</option>
           <option v-for="(row, index) in filteredUsers" :key="row.id" :value="row.id">{{ row.name }}</option>
          </select>
          <div v-if="errors.parent_id" class="text-danger small mt-1">{{ errors.parent_id[0] }}</div>
         </div>
         </div>

         <div class="col-md-6">
         <div class="mb-3">
          <label class="form-label" data-bs-toggle="tooltip" title="Access for all (Leads, Quotations, Proforma Invoice and Invoice)">Access for all <i class="ti ti-info-octagon"></i></label> <br>
          <div class="form-check form-check-inline form-checkbox-success mb-2">
           <input type="checkbox" class="form-check-input me-2" name="can_view_all" id="can_view_all" v-model="can_view_all">
           <label class="form-check-label" for="can_view_all">Can View All</label>
          </div>
         </div>
         </div>
              
        </div>
        
        </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
         <center> 
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
         </center> 
          <h4 class="mb-1 text-center">Confirm Delete</h4>
          <p class="mb-3 text-center">
           Some data for this user needs to be transferred to another user. Please select user where you want to transfer the data.
          </p>
          <label class="form-label">User</label>
          <select class="form-control mb-3" v-model="data_transfer_to_user_id">
           <option v-if="auth?.type === 'ADMIN'" :value="auth?.id" selected>{{ auth?.name }}</option>
           <option v-for="row in filteredUsers" :value="row?.id" :key="row?.id">{{ row.name }}</option>
          </select>
          <div v-if="errors.data_transfer_to_user_id" class="text-danger small">{{ errors.data_transfer_to_user_id[0] }}</div>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteAdmin">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
